module.exports = __webpack_public_path__ + "img/1170877599.4fa52559.jpg";